import React from "react";
import { RCCGrid, RCCHidden } from "react-common-components";
import formatDate from "src/utils/formatDate";
import formatNumber from "src/utils/formatNumber";
import { useTranslation } from "src/context/Translations/context";
import { maxWidthXs, StyledSpan } from "./styles";
import { IComponentColumn } from "./interface";
import { getStyles } from ".";

const Column: React.FC<IComponentColumn> = ({
	column,
	dt,
	index
}) => {
	const { currentLanguage } = useTranslation();
    
	return (
		<RCCHidden only={column.hidden}>
			<RCCGrid											
				item
				container
				alignItems="center"
				xs={column.xs}
				sm={column.sm}
				md={column.md}
				lg={column.lg}
				justifyContent={
					column.justify === "left" && "flex-start" ||
                    column.justify === "right" && "flex-end" ||
                    "center"
				}
				style={getStyles(column.truncate)}
				styleInline={`${maxWidthXs} ${column.styleInline ? column.styleInline : ""}`}
			>
				{column.cellRenderer ? column.cellRenderer(dt, index) : 
					<StyledSpan
						truncate={column.truncate}
						title={dt[column.idColumn]}
						bold={column.bold}
					>
						<RCCHidden smUp>
							<StyledSpan
								bold
								style={{marginRight: "4px"}}
							>
								{column.nameColumn}:
							</StyledSpan>
						</RCCHidden>
						{column.type === "date" && formatDate(new Date(dt[column.idColumn]), currentLanguage)}
						{column.type === "number" && formatNumber(dt[column.idColumn], currentLanguage)}
						{column.type !== "date" && column.type !== "number" && dt[column.idColumn]}
					</StyledSpan>
				}     
			</RCCGrid>
		</RCCHidden>
	);
};

export default Column;
